import BackArrowIcon from './Icons/BackArrowIcon';

interface BackButtonProps {
    /** Icon-only, so this is the only name a screen reader gets. */
    label?: string;
    onClick: () => void;
}

const BackButton = ({label, onClick}: BackButtonProps) => {
    return (
        <button
            type='button'
            aria-label={label}
            onClick={onClick}
            className='flex size-11 shrink-0 cursor-pointer items-center justify-center rounded-full bg-light-silver outline-none focus-visible:outline-2 focus-visible:outline-primary dark:bg-orion-2 dark:focus-visible:outline-romance'
        >
            <BackArrowIcon />
        </button>
    );
};

export default BackButton;
